import { useCallback, useEffect, useState } from "react";
import { Cloud, Unplug, UploadCloud } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fmtDateTime } from "@/lib/api";
import { Card } from "@/components/Ui";
import { Button } from "@/components/ui/button";

export function OffsiteCard({ onCopied }) {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => api.get("/drive/status").then((r) => setS(r.data)).catch(() => {}), []);
  useEffect(() => {
    load();
    const q = new URLSearchParams(window.location.search).get("drive");
    if (q === "ok") toast.success("Google Drive collegato");
    if (q === "error") toast.error("Collegamento a Google Drive non riuscito");
    if (q) window.history.replaceState({}, "", "/backup");
  }, [load]);

  const connect = async () => {
    try { const { data } = await api.get("/drive/connect"); window.location.href = data.authorization_url; } catch (e) { toast.error(errMsg(e)); }
  };
  const act = async (fn, ok) => {
    setBusy(true);
    try { await fn(); toast.success(ok); load(); onCopied?.(); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  if (!s) return null;

  return (
    <Card className="p-5 mb-8" data-testid="offsite-card">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div className="flex items-start gap-3">
          <Cloud className="h-5 w-5 text-sky-600 mt-0.5" />
          <div>
            <p className="font-heading font-semibold text-slate-900">Copia esterna — Google Drive aziendale (regola 3-2-1)</p>
            <p className="text-xs text-slate-500 mt-1">{s.schedule}. La copia resta cifrata AES-256: Google non può leggerne il contenuto. Integrità verificata con MD5; conservazione {s.retention_days / 7} settimane.</p>
            <p className="text-xs mt-2" data-testid="offsite-status">
              {!s.configured ? <span className="text-amber-700">Non configurato: servono le credenziali OAuth di Google (Client ID e Secret).</span>
                : s.connected ? <span className="text-emerald-700">Collegato a {s.account} dal {fmtDateTime(s.connected_at)}</span>
                : <span className="text-amber-700">Non collegato</span>}
              {s.last_copy && <span className="text-slate-500"> · Ultima copia: {fmtDateTime(s.last_copy.offsite.at)} ({s.last_copy.offsite.file_name})</span>}
            </p>
          </div>
        </div>
        <div className="flex gap-2 shrink-0">
          {s.configured && !s.connected && <Button onClick={connect} className="bg-[#0A2540] hover:bg-[#031B33] text-white" data-testid="offsite-connect">Collega Google Drive</Button>}
          {s.connected && (
            <>
              <Button disabled={busy} variant="outline" onClick={() => act(() => api.post("/drive/copy-now"), "Copia inviata e verificata su Google Drive")} data-testid="offsite-copy-now"><UploadCloud className="h-4 w-4 mr-1" />{busy ? "Invio…" : "Copia ora"}</Button>
              <Button disabled={busy} variant="ghost" className="text-red-600" onClick={() => window.confirm("Scollegare Google Drive?") && act(() => api.post("/drive/disconnect"), "Google Drive scollegato")} data-testid="offsite-disconnect"><Unplug className="h-4 w-4" /></Button>
            </>
          )}
        </div>
      </div>
    </Card>
  );
}
